export default __webpack_public_path__ + "static/media/multi-pitch.3fbe124e.png";